var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1182 5.46967C19.4111 5.76256 19.4111 6.23744 19.1182 6.53033L7.11822 18.5303C6.82533 18.8232 6.35045 18.8232 6.05756 18.5303C5.76467 18.2374 5.76467 17.7626 6.05756 17.4697L18.0576 5.46967C18.3505 5.17678 18.8253 5.17678 19.1182 5.46967Z",
    fill: "#373843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05756 5.46967C5.76467 5.76256 5.76467 6.23744 6.05756 6.53033L18.0576 18.5303C18.3505 18.8232 18.8253 18.8232 19.1182 18.5303C19.4111 18.2374 19.4111 17.7626 19.1182 17.4697L7.11822 5.46967C6.82533 5.17678 6.35045 5.17678 6.05756 5.46967Z",
    fill: "#373843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlackIcon);
export default __webpack_public_path__ + "static/media/cross-black-icon.065e0f2f9e2b233c432a030ce6e56451.svg";
export { ForwardRef as ReactComponent };